import React, { useState } from "react";
import styles from "./FooterAccordian.module.css";
import { JokerButton, ButtonType, ButtonSize } from "material-ui-jokerpro";
import clsx from "clsx";
import AssetsPack from "../../util/AssetsPack";
import ImageComponent from "../ImageComponent";
interface FooterAccordianProps {
  data: ListData;
}

export type LinkData = { name: string; url: string };
export type ListData = { title: string; list: LinkData[] };

const FooterAccordian = ({ data }: FooterAccordianProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const content = (
    <div className={styles["footer_accordian"]}>
      <span className={styles["title"]} onClick={() => setIsOpen(!isOpen)}>
        {data.title}
        <ImageComponent
          src={AssetsPack.icons.DOWN_ARROW_ICON.default}
          alt="arrow"
          className={clsx({ [styles["open"]]: isOpen })}
        />
      </span>
      <ul className={clsx({ [styles["open"]]: isOpen })}>
        {data.list.map((value) => {
          return (
            <li key={value.name}>
              <JokerButton
                type={ButtonType.Link}
                text={value.name}
                href={value.url}
                size={ButtonSize.Small}
                style={{ color: "#5F5F5F" }}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );

  return content;
};

export default FooterAccordian;
